import { yup } from '@framework/validation';
import React from 'react';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { CommonContainerWidgetConfigSchema } from '../common/CommonContainerWidgetConfigSchema';
import { IColumnWidget } from './IColumnWidget';

export const ColumnWidgetConfigSchema: yup.ObjectSchema<IColumnWidget> =
  CommonContainerWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Column).required(),
  });

export interface IColumnWidgetConfigComponentProps
  extends IWidgetComponentProps<IColumnWidget> {}

export function ColumnWidgetConfigComponent(
  props: IColumnWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
    </div>
  );
}
